import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import UserAgent from 'helpers/device';

class ModeSwitch extends Component {
    onClick(mode) {
        this.props.dispatch(Action.set('ModeFilter', mode));
    }

    render() {
        const {sportConfig} = this.props;

        if (!sportConfig.isLateswapModeUsed() && !sportConfig.isBacktestModeUsed()) {
            return '';
        }

        return (
            <div className="mode-cell">
                <label className="label-alt">Mode</label>
                <div className="filter-btn-group">
                    {Object.keys(Const.MODES).map((mode) => {
                        if (!sportConfig.isModeUsed(mode)) {
                            return;
                        }

                        if (UserAgent.isMobile() && mode === Const.MODE_LATESWAP) {
                            return;
                        }

                        return (
                            <button
                                type="button"
                                key={mode}
                                className={sportConfig.isModeEqual(mode) ? 'active' : ''}
                                onClick={(e) => ::this.onClick(mode)}
                            >
                                {Const.MODES[mode]}
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    return {
        sportConfig: state.sportConfig,
    };
}

export default connect(mapStatesToProps)(ModeSwitch);
